import {SET_ELEMENT, LICENSE_FIX, SET_COPYRIGHT_LICENSE, COPYRIGHT_LICENSE_SHOW_MODAL, SET_PERFORMED_MULTI_LICENSE_EXCLUSION} from '../constants/constants';

const excludeInitialState={
    element: {},
    isGlobalExclusionAvailable : false,
    domain: null,
    isMultiple: false
}

export const elementExclusion=(state=excludeInitialState, action={})=>{
    if(action.type===SET_ELEMENT){
        return {...action.payload}
    }
    return state
}
const multiLicenseExclusionProgressInitialState={
    performedMultiLicenseExclusion: false
}
export const multiLicenseExclusionProgress = (state=multiLicenseExclusionProgressInitialState, action={}) => {
    if(action.type===SET_PERFORMED_MULTI_LICENSE_EXCLUSION) {
        return { ...state, performedMultiLicenseExclusion: action.payload.value}
    }
    return state
}

const licenseFixInitialState = {
    licenseToFix: {}
}

export const licenseFix = (state=licenseFixInitialState, action={})=>{
    if(action.type===LICENSE_FIX){
        return {
            licenseToFix: action.payload
        }
    }
    return state
}

const copyrightLicenseInitialState = {
    library: null
}
export const copyrightLicense = (state=copyrightLicenseInitialState, action={}) => {
    if(action.type===SET_COPYRIGHT_LICENSE) {
        return {
            library: action.payload.library
        }
    }
    return state
}